/* tslint:disable */
import {
  ChatMessage,
  KanvasUser
} from '../index';

declare var Object: any;
export interface ChatRoomInterface {
  "name"?: string;
  "id"?: number;
  "kanvasUserId"?: string;
  chatMessages?: ChatMessage[];
  kanvasUser?: KanvasUser;
  roomMembers?: KanvasUser[];
}

export class ChatRoom implements ChatRoomInterface {
  "name": string;
  "id": number;
  "kanvasUserId": string;
  chatMessages: ChatMessage[];
  kanvasUser: KanvasUser;
  roomMembers: KanvasUser[];
  constructor(data?: ChatRoomInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `ChatRoom`.
   */
  public static getModelName() {
    return "ChatRoom";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of ChatRoom for dynamic purposes.
  **/
  public static factory(data: ChatRoomInterface): ChatRoom{
    return new ChatRoom(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'ChatRoom',
      plural: 'ChatRooms',
      path: 'ChatRooms',
      idName: 'id',
      properties: {
        "name": {
          name: 'name',
          type: 'string'
        },
        "id": {
          name: 'id',
          type: 'number'
        },
        "kanvasUserId": {
          name: 'kanvasUserId',
          type: 'string'
        },
      },
      relations: {
        chatMessages: {
          name: 'chatMessages',
          type: 'ChatMessage[]',
          model: 'ChatMessage',
          relationType: 'hasMany',
                  keyFrom: 'id',
          keyTo: 'chatRoomId'
        },
        kanvasUser: {
          name: 'kanvasUser',
          type: 'KanvasUser',
          model: 'KanvasUser',
          relationType: 'belongsTo',
                  keyFrom: 'kanvasUserId',
          keyTo: 'id'
        },
        roomMembers: {
          name: 'roomMembers',
          type: 'KanvasUser[]',
          model: 'KanvasUser',
          relationType: 'hasMany',
          modelThrough: 'ChatRoomKanvasUser',
          keyThrough: 'kanvasUserId',
          keyFrom: 'id',
          keyTo: 'chatRoomId'
        },
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/sdk/models/ChatRoom.ts